import script from "./BubbleComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./BubbleComponent.vue?vue&type=script&setup=true&lang=js"

import "./BubbleComponent.vue?vue&type=style&index=0&id=6340eef6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6340eef6"]])

export default __exports__